"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.YouTag = void 0;
var react_1 = __importDefault(require("react"));
var YouTag = function () {
    return react_1.default.createElement("div", { className: "text-[10px] text-sm bg-cyan-500 px-1 py-[2px] rounded-md text-white" }, "YOU");
};
exports.YouTag = YouTag;
